import React from 'react'
import IconWrapper, { IconProps } from './IconWrapper'

export const AppreciationIcon = (props: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
        >
            <path
                d="M20.5937 12.6554L12 21.1667L3.40625 12.6554C2.83941 12.1038 2.39292 11.4409 2.0949 10.7082C1.79687 9.97561 1.65377 9.18922 1.67459 8.39857C1.69542 7.60793 1.87973 6.83016 2.21591 6.11424C2.55209 5.39833 3.03286 4.75977 3.62795 4.23879C4.22304 3.71781 4.91956 3.32569 5.67364 3.08712C6.42772 2.84855 7.22303 2.76869 8.00948 2.85259C8.79594 2.93648 9.55651 3.18231 10.2433 3.57458C10.9301 3.96686 11.5282 4.49709 12 5.13188C12.4738 4.5017 13.0727 3.9761 13.759 3.58799C14.4453 3.19988 15.2043 2.9576 15.9886 2.87633C16.7728 2.79506 17.5654 2.87653 18.3167 3.11566C19.068 3.35479 19.7619 3.74642 20.3549 4.26605C20.9479 4.78567 21.4273 5.4221 21.763 6.13551C22.0987 6.84891 22.2836 7.62393 22.306 8.41207C22.3284 9.2002 22.1879 9.98448 21.8933 10.7158C21.5987 11.4471 21.1562 12.1098 20.5937 12.6623"
                strokeLinecap="round"
                strokeLinejoin="round"
            />{' '}
        </svg>
    </IconWrapper>
)
